export default "__VITE_ASSET__DoyWLjUg__"